import { ForkLiftJobService } from '@gtpl/shared-services/warehouse-management';
import React, { useEffect, useRef, useState } from 'react'
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Button, DatePicker, Card, Input, message, Table, Form, Col, Select, Row } from 'antd';
import moment from 'moment';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { useForm } from 'antd/lib/form/Form';

export const ReprocessingView = () => {
    const [jobcodesData, setJobcodesData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const searchInput = useRef(null);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [newLotNoData, setNewLotNoData] = useState<any[]>([]);
    const [jobNumberData, setJobNumberData] = useState<any[]>([]);
    const service = new ForkLiftJobService();
    const { Option } = Select;
    const [form] = useForm()
    useEffect(() => {
        getReprocessingDataForView();
        getNewLotNoForReprocessing()
        getJobNumberForReprocessing()
    }, []);

    const getReprocessingDataForView = async (values?: any) => {
        const jobCode = values?.jobCode || '';
        const newLotNo = values?.newLotNo || '';
        const dateRange = values?.jobDate;

        const req: any = {
            jobNo: jobCode,
            newLotNo: newLotNo,
        };

        if (dateRange && dateRange[0]) {
            req.fromDate = dateRange[0].format('YYYY-MM-DD');
            req.toDate = dateRange[1].format('YYYY-MM-DD');
        }

        setLoading(true);

        try {
            const res = await service.getReprocessingDataForView(req);

            if (res?.status) {
                const data = Array.isArray(res.data) ? res.data : [];

                const withKeys = data.map((d: any, idx: number) => ({
                    key: d.jobId ?? d.jobCode ?? idx,
                    ...d,
                }));

                setJobcodesData(withKeys);
            } else {
                AlertMessages.getErrorMessage(
                    res?.internalMessage || 'Failed to fetch data'
                );
                setJobcodesData([]);
            }
        } catch (err: any) {
            AlertMessages.getErrorMessage(
                err?.internalMessage || err?.message || 'Error fetching data'
            );
            setJobcodesData([]);
        } finally {
            setLoading(false);
        }
    };

    const getNewLotNoForReprocessing = () => {
        service.getNewLotNoForReprocessing().then((res) => {
            if (res.status) {
                setNewLotNoData(res.data)
            } else {
                setNewLotNoData([])
            }
        }).catch((err) => {
            console.error('API Error:', err);
            message.error('Failed to fetch data');
            setNewLotNoData([])
        })
    }

    const getJobNumberForReprocessing = () => {
        service.getJobNumberForReprocessing().then((res) => {
            if (res.status) {
                setJobNumberData(res.data)
            } else {
                setJobNumberData([])
            }
        }).catch((err) => {
            console.error('API Error:', err);
            message.error('Failed to fetch data');
            setJobNumberData([])
        })
    }
    function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
        setSearchedColumn('');
    };
    const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
        </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
        </Button>
            </div>
        ),
        filterIcon: filtered => (
            <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : false,
        onFilterDropdownVisibleChange: visible => {
            if (visible) { setTimeout(() => searchInput.current.select()); }
        },
        render: text =>
            text ? (
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : text
            )
                : null

    });

    const onReset = () => {
        form.resetFields()
        getReprocessingDataForView()
    }



    const columns = [
        {
            title: 'S No',
            dataIndex: 'sno',
            key: 'sno',
            render: (_: any, __: any, index: number) => index + 1,
            width: 70,
        },
        {
            title: 'Job Date',
            dataIndex: 'jobDate',
            key: 'jobDate',
            sorter: (a: any, b: any) =>
                new Date(a.jobDate).getTime() - new Date(b.jobDate).getTime(),
            render: (val: string) =>
                val ? moment(val).format('DD-MM-YYYY') : '-',
        },
        {
            title: 'Job Code',
            dataIndex: 'jobCode',
            key: 'jobCode',
            sorter: (a: any, b: any) =>
                (a.jobCode || '').localeCompare(b.jobCode || ''),
            ...getColumnSearchProps('jobCode'),
        },
        // {
        //     title: 'Job Purpose',
        //     dataIndex: 'jobPurpose',
        //     key: 'jobPurpose',
        //     sorter: (a: any, b: any) =>
        //         (a.jobPurpose || '').localeCompare(b.jobPurpose || ''),
        //     ...getColumnSearchProps('jobPurpose'),
        // },
        {
            title: 'Stock Type',
            dataIndex: 'stockType',
            key: 'stockType',
            sorter: (a: any, b: any) =>
                (a.stockType || '').localeCompare(b.stockType || ''),
            ...getColumnSearchProps('stockType'),
        },
        {
            title: 'Old Lot No',
            dataIndex: 'oldLotNo',
            key: 'oldLotNo',
            sorter: (a: any, b: any) =>
                (a.oldLotNo || '').localeCompare(b.oldLotNo || ''),
            ...getColumnSearchProps('oldLotNo'),
        },
        {
            title: 'New Lot No',
            dataIndex: 'newLotNo',
            key: 'newLotNo',
            sorter: (a: any, b: any) =>
                (a.newLotNo || '').localeCompare(b.newLotNo || ''),
            ...getColumnSearchProps('newLotNo'),
        },
        {
            title: 'Pack Style',
            dataIndex: 'packStyle',
            key: 'packStyle',
            sorter: (a: any, b: any) =>
                (a.packStyle || '').localeCompare(b.packStyle || ''),
            ...getColumnSearchProps('packStyle'),
        },
        {
            title: 'PO Number',
            dataIndex: 'poNumber',
            key: 'poNumber',
            sorter: (a: any, b: any) =>
                (a.poNumber || '').localeCompare(b.poNumber || ''),
            ...getColumnSearchProps('poNumber'),
        },
        {
            title: 'Variant',
            dataIndex: 'shortCode',
            key: 'shortCode',
            sorter: (a: any, b: any) =>
                (a.shortCode || '').localeCompare(b.shortCode || ''),
            ...getColumnSearchProps('shortCode'),
        },
        {
            title: 'Job Cartons',
            dataIndex: 'jobCartons',
            key: 'jobCartons',
            sorter: (a: any, b: any) =>
                Number(a.jobCartons || 0) - Number(b.jobCartons || 0),
            ...getColumnSearchProps('jobCartons'),
        },
        {
            title: 'Issued Qty',
            dataIndex: 'issuedQuantity',
            key: 'issuedQuantity',
            sorter: (a: any, b: any) =>
                Number(a.issuedQuantity || 0) - Number(b.issuedQuantity || 0),
            ...getColumnSearchProps('issuedQuantity'),
        },
    ];

    return (
        <Card title={<span style={{ color: 'white' }}>Reprocessing View</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
            <Form form={form} layout="vertical" style={{ marginBottom: '16px' }} onFinish={getReprocessingDataForView} >
                <Row gutter={16} align="middle">
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                        <Form.Item name="jobDate" label="Job Date">
                            <DatePicker.RangePicker style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                        <Form.Item name="newLotNo" label="New Lot No">
                            <Select
                                placeholder="Select New Lot No"
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option: any) => (option?.children || '').toString().toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                allowClear
                                dropdownMatchSelectWidth={false}
                                style={{ width: '100%' }}
                            >
                                {newLotNoData.filter((fil) => fil.lotNo !== null).map((dropData: any) => (
                                    <Option key={dropData.lotNo} value={dropData.lotNo}>{dropData.lotNo}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                        <Form.Item name="jobCode" label="Job Code">
                            <Select
                                placeholder="Select Job Code"
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option: any) => (option?.children || '').toString().toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                allowClear
                                dropdownMatchSelectWidth={false}
                                style={{ width: '100%' }}
                            >
                                {jobNumberData.map((dropData: any) => (
                                    <Option key={dropData.jobCode} value={dropData.jobCode}>{dropData.jobCode}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }} style={{marginTop: '30px'}}>
                        <Form.Item>
                            <Button type='primary' htmlType="submit" style={{ marginRight: 8 }}>Search</Button>
                            <Button danger onClick={onReset}>Reset</Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <Table
                columns={columns}
                dataSource={jobcodesData}
                loading={loading}
                scroll={{ x: 'max-content' }}
                pagination={{ pageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '50'] }}
                rowKey={(record: any) => record.key}
                bordered
            />
        </Card>
    )
}
